var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{attrs:{"type":"is-warning","closable":false,"has-icon":"","role":"alert"}},[_c('h3',{staticClass:"title is-6 mb-2"},[_vm._t("header")],2),_vm._v(" "),_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }